export const styles = {
    fontSize: '--setting-font-size',
    fontFamily: '--setting-font-family',
} as const;

export const classNames = {
    scrollbars: 'feature-scrollbars-off',
    animations: 'feature-animations-off',
} as const;
